export const ENDPOINTS = {
  LECTURES: "/lectures/categories",
  TOP_LANGUAGES: "/top-languages",
  CURRICULUM: "/curriculum/recommendation", // /curriculum/recommendation?category=:category
  LECTURE: "/lectures", // /lectures/:lectureId
  OTHERS: "/others", // /others, /others/:userId/lectures,
  KEYWORDS: "/keywords",
};
